import { ImportExternalErpContainerTypesFlow } from '@Components/Stammdaten';
import { TableWithStoredSettingsAndLayoutSettings } from '@Components/Tables/TableWithStoredSettingsAndLayoutSettings';
import { STAMMDATEN_API } from '@Constants/backendConstants';
import { Permission } from '@Constants/Permission.g';
import { containerTypeColumns } from '@Constants/TableColumns';
import { useHasPermission } from '@Contexts/appContext';
import { useExternalErpImport } from '@Hooks/Stammdaten/useExternalErpImport';
import { EnumFrontendLayoutSetting, type ApiContainerType } from '@Model';
import { useListApi } from '@Hooks/useListApi';
import { ContainerTypesRepository } from '@Repositories/Stammdaten';

export function FrameListContainerType() {
    const hasPermission = useHasPermission();

    const module = useListApi(ContainerTypesRepository, STAMMDATEN_API);

    const { toolbarElements, flowProps, tableKey } = useExternalErpImport('Containertypen importieren');

    return (
        <>
            <TableWithStoredSettingsAndLayoutSettings<ApiContainerType>
                layoutSettingsContext={EnumFrontendLayoutSetting.ContainerTypesTableLayout}
                name="ContainerTypeList"
                columns={containerTypeColumns}
                loader={module.loadPage}
                canCreate={hasPermission(Permission.StammdatenContainerTypeCreate)}
                key={tableKey}
                useOnClickNavigation
                fullSize
                toolbarElements={toolbarElements}
            />
            <ImportExternalErpContainerTypesFlow {...flowProps} />
        </>
    );
}
